// extracted by mini-css-extract-plugin
module.exports = {"root":"RemoveFieldset_root__3V81Y"};